/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutAlignMiddleFilled = createReactComponent("filled", "layout-align-middle-filled", "IconLayoutAlignMiddleFilled", [["path", { "d": "M13 5a3 3 0 0 1 3 3v3h4a1 1 0 0 1 0 2h-4v3a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-3h-4a1 1 0 0 1 0 -2h4v-3a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

export { IconLayoutAlignMiddleFilled as default };
//# sourceMappingURL=IconLayoutAlignMiddleFilled.mjs.map
